
define('jst!filefinder/_tab_upload',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="tab tab-upload">\n  <p><%= t(\'Select files from your computer. #filefinder\') %></p>\n  <input type="hidden" class="files-hidden-input" />\n\n  <%- button(t(\'Choose files #uploader\'), \'\', { \'class\':\'baby-button uploader-button\', \'color\': \'secondary\', \'tabindex\' : 1 }) %>\n\n  <div class="drag-tip-wrapper">\n    <div class="icon icon-32 icon-32-add-file"></div>\n    <p><%= t("Drag \'n drop files here. #filefinder") %></p>\n  </div>\n</div>\n');
 });

